import React from 'react';

import StepTitle from '@vlabs/shared/legacy-components/steps/StepTitle';
import { Step } from '@vlabs/uikit';

import st from './shared.module.sass';
import { useCreateHandlerTranslation } from '../../../create-handler/i18n.ts';
import { CommonSubForm } from '../../../forms';

function StepCommon() {
  const { t } = useCreateHandlerTranslation();

  return (
    <Step
      className={st.Step}
      title={(
        <StepTitle>
          {t('other_scenario.basic_parameters')}
        </StepTitle>
      )}
    >
      <CommonSubForm />
    </Step>
  );
}

StepCommon.fieldNames = [
  'description',
  'owner_department_id',
];

export { StepCommon };
